'use client'

import { formatRate } from '@polaris/core/utils'
import { useAtomValue } from 'jotai'
import { Button } from '@/src/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/src/components/ui/dialog'
import { useSwapFormSubmit } from '@/src/stores/swap/actions'
import { priceImpactAtom } from '@/src/stores/swap/atoms'

type PriceImpactConfirmationAlertProps = {
  isOpen?: boolean
  setIsOpen?: (isOpen: boolean) => void
}

export const PriceImpactConfirmationAlert = ({
  isOpen,
  setIsOpen,
}: PriceImpactConfirmationAlertProps) => {
  const { onSubmit } = useSwapFormSubmit()
  const priceImpact = useAtomValue(priceImpactAtom) ?? 0
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        aria-describedby={undefined}
        showBackButton={false}
        showCloseButton={false}
        className='max-w-[320px] p-6 h-min'
      >
        <DialogHeader>
          <DialogTitle className='text-xl mb-2'>
            Trade with high price impact?
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className='text-sm mb-6'>
          Your trade will likely result in a{' '}
          <strong>{formatRate(priceImpact)}</strong> loss if you proceed with
          this trade.
        </DialogDescription>

        <div className='flex flex-col items-center gap-2'>
          <Button
            variant='danger'
            size='lg'
            onClick={() => {
              onSubmit()
              if (setIsOpen) setIsOpen(false)
            }}
            autoFocus={false}
            className='w-full'
          >
            Proceed
          </Button>
          <div className='w-full p-5 interaction-none'>
            <Button
              variant='ghost'
              size='lg'
              className='text-link w-full'
              onClick={() => {
                if (setIsOpen) setIsOpen(false)
              }}
              autoFocus={true}
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
